import Tag from "@xtribe/shared/components/lib/tag";
import dayjs from "dayjs";

type Props = {
  date: Date;
  lessons: number;
  first?: boolean;
  last?: boolean;
};

const CalendarDate: React.FC<Props> = ({ date, lessons, last, first }) => {
  const isToday = dayjs(date).isSame(new Date(), "date");
  const dateContent = (
    <>
      <div className="flex justify-center lg:justify-between">
        <p className="font-medium mr-2">{dayjs(date).format("dddd")}</p>
        <Tag
          type={lessons > 0 && dayjs(date) ? "success" : "lite"}
          invert={lessons > 0}
        >
          {lessons}
        </Tag>
      </div>
      <p className="text-sm text-gray-700">{dayjs(date).format("MMMM DD")}</p>
    </>
  );
  return (
    <div
      className={`relative text-center lg:text-left bg-gray-50  flex-1 border border-gray-100 overflow-hidden ${
        first ? "rounded-l-lg" : last ? "rounded-r-lg" : ""
      }`}
      style={{
        marginRight: -1,
      }}
    >
      <div
        className={`w-full h-full px-4 pt-6 pb-4 border-t ${
          isToday ? "border-primary" : "border-transparent"
        }`}
      >
        {dateContent}
      </div>
    </div>
  );
};

export default CalendarDate;
